// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5687":"3f4b4528cc39ce6e","7713":"321ec87d1e396f79","9589":"fb836cc346f34465"}[chunkId] + ".css";
};